import { Component } from '@angular/core';

@Component({
  selector: 'app-real-state',
  templateUrl: './real-state.component.html',
  styleUrl: './real-state.component.scss'
})
export class RealStateComponent {

}
